var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M42.6875 0.265625V36.8516H34.8125V0.265625H42.6875ZM43.9453 43.3047V49.5938H8.67188V33.2422H16.6562V43.3047H43.9453ZM20.2109 7.8125C20.1562 14.1562 23.1641 20.5 31.6953 23.125L27.7031 29.3047C22.0977 27.5 18.3516 24 16.1641 19.5156C13.8945 24.3555 10.0117 28.2383 4.1875 30.125L0.0859375 23.9453C8.83594 21.1016 12.0078 14.2656 12.0078 7.8125V3H20.2109V7.8125Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText08);
export default __webpack_public_path__ + "static/media/text08.0369857396b4622ec27dc6733a15b6b4.svg";
export { ForwardRef as ReactComponent };